import { render, staticRenderFns } from "./SwitchAdminToUser.vue?vue&type=template&id=6c96aa50&scoped=true"
import script from "./SwitchAdminToUser.vue?vue&type=script&lang=js"
export * from "./SwitchAdminToUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96aa50",
  null
  
)

export default component.exports